module.exports = scm;